import React from "react";

export type LinkProps = {
    children: React.ReactNode;
    href: string;
};

const ExternalLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
    ({ href, children, ...props }, ref) => (
        <a ref={ref} href={href} rel="noopener noreferrer" target="_blank" {...props}>
            {children}
        </a>
    ),
);

export default React.memo(ExternalLink);
